module.exports = __webpack_public_path__ + "img/medcube_banner.b9c57b6a.png";